import type { CampaignStepEntity } from "./CampaignStepEntity";
import type { CampaignUserEntity } from "./CampaignUserEntity";

export class CampaignsMiniEntity {
    id?: number;
    createdAt?: string;
    updatedAt?: string;
    startDate?: string;
    endDate?: string;
    steps?: Array<CampaignStepEntity> | null;
    users?: Array<CampaignUserEntity> | null;
    priority?: number | null;
    name?: string;
    isActive?: boolean;
    maxUsage?: number | null;
    maxUserUsage?: number | null;
}
